import { render } from "./WelcomeCard.vue?vue&type=template&id=297762a2&scoped=true"
import script from "./WelcomeCard.vue?vue&type=script&lang=js"
export * from "./WelcomeCard.vue?vue&type=script&lang=js"

import "./WelcomeCard.vue?vue&type=style&index=0&id=297762a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297762a2"]])

export default __exports__